import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { JurisdictionPrefixPipe } from "./jurisdiction-prefix.pipe";
import { JurisdictionTranslatePipe } from "./jurisdiction-translate.pipe";

@NgModule({
	imports: [TranslateModule],
	providers: [JurisdictionPrefixPipe, JurisdictionTranslatePipe],
	declarations: [JurisdictionPrefixPipe, JurisdictionTranslatePipe],
	exports: [JurisdictionPrefixPipe, JurisdictionTranslatePipe],
})
export class JurisdictionPrefixModule {}
